<template>
  <div class="hc-banner" data-testid="hc-banner-root">
    <img
      v-if="image"
      class="hc-banner__image"
      :src="image"
      :alt="title"
      loading="lazy"
    />
    <div class="hc-banner__content">
      <span v-if="tag" class="hc-banner__tag">{{ tag }}</span>
      <h3 v-if="title" class="hc-banner__title">{{ title }}</h3>
      <p v-if="subtitle" class="hc-banner__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
import { safeUrl } from '../../blockConfig';

export default {
  name: 'BannerBlock',
  props: {
    config: { type: Object, default: () => ({}) },
  },
  computed: {
    tag() {
      return (this.config && this.config.tag) || '';
    },
    title() {
      return (this.config && this.config.title) || '';
    },
    subtitle() {
      return (this.config && this.config.subtitle) || '';
    },
    image() {
      return safeUrl(this.config && this.config.image);
    },
  },
};
</script>

<style src="./styles/BannerBlock.scss" lang="scss" scoped></style>
